import React from 'react';
import './AppLoader.css';

export default function AppLoader({
  label = null,
  size = 'md',
  variant = 'default',
  className = '',
}) {
  const classes = [
    'app-loader',
    `app-loader--${size}`,
    `app-loader--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} role="status" aria-live="polite">
      <div className="app-loader__stack">
        <span className="app-loader__spinner" aria-hidden="true" />
        {label ? <div className="app-loader__label">{label}</div> : null}
      </div>
    </div>
  );
}
